export class ImageChangeHandler {
  constructor(controller) {
    this.controller = controller;
  }

  initializeImageChangeHandlers() {
    // Only keep logic that is not related to double-click or modal
    // For example, external image selection event handler
    document.addEventListener('image:selected', (event) => {
      const imagePath = event.detail.path;
      if (window.currentEditingImage) {
        window.currentEditingImage.src = imagePath;
        window.currentEditingImage = null;
      }
    });
  }
}